import { alertVariants } from "@visiblethread/react-components";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { hideInlineAlert, showInlineAlert } from "slices/app/appSlice";

export const useArchivedInlineAlert = ({
  isArchived = false,
  label = "item",
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isArchived) {
      dispatch(
        showInlineAlert({
          variant: alertVariants.warning,
          text: `You cannot edit this archived ${label}. Click unarchive to edit.`,
        })
      );
    } else {
      dispatch(hideInlineAlert());
    }

    return () => {
      dispatch(hideInlineAlert());
    };
  }, [isArchived, label]);
};
